type PrefillHydrationState = {
  hydrateOncePerSource: boolean;
  sourceKey: string;
  hydratedSourceKey: string | null;
  isFetching: boolean;
  isError: boolean;
};

/** Wait for fresh data once, then preserve the user's draft for this source. */
export const shouldHydrateOrderDocumentPrefill = ({
  hydrateOncePerSource,
  sourceKey,
  hydratedSourceKey,
  isFetching,
  isError,
}: PrefillHydrationState): boolean => !hydrateOncePerSource || (!isFetching && !isError && hydratedSourceKey !== sourceKey);
